import { isNullish } from '../../shared/utils';
import { AusResult, AusResultStatusIcon, AusSystem, LpaResult, LpaResultStatusIcon, OrderLogModel } from './aus-types.model';
import moment from 'moment';

export const GetLatestDuOrderLog = (log: OrderLogModel[]): OrderLogModel => {
  const latestLog = log?.filter((l) => l.system === AusSystem.DU).sort((a, b) => b.responseTime?.localeCompare(a.responseTime))[0];
  return latestLog;
};

export const GetLatestDuEaOrderLog = (log: OrderLogModel[]): OrderLogModel => {
  const latestLog = log?.filter((l) => l.system === AusSystem.DU_EA).sort((a, b) => b.responseTime?.localeCompare(a.responseTime))[0];
  return latestLog;
};

export const GetLatestLpaOrderLog = (log: OrderLogModel[]): OrderLogModel => {
  const latestLog = log?.filter((l) => l.system === AusSystem.LP).sort((a, b) => b.responseTime?.localeCompare(a.responseTime))[0];
  return latestLog;
};

export const GetLastRunDate = (log: OrderLogModel[]): Date => {
  const lastRunDate = moment(log?.sort((a, b) => b.responseTime?.localeCompare(a.responseTime))[0]?.responseTime).toDate();
  return lastRunDate;
};

export const GetDuStatusHtml = (result: AusResult): string => {
  const status = !isNullish(result) ? AusResultStatusIcon[result] : AusResultStatusIcon[AusResult.Incomplete];
  return `<i class="street-light pe-1 ${status}"></i><div class="fw-bold pe-1"> DU </div> `;
};

export const GetLpaStatusHtml = (result: LpaResult): string => {
  const status = !isNullish(result) ? LpaResultStatusIcon[result] : LpaResultStatusIcon[LpaResult.Incomplete];
  return `<i class="street-light px-1 ${status}"></i><div class="fw-bold pe-1"> LPA </div>`;
};

export const GetDuEaStatusHtml = (result: AusResult): string => {
  const status = !isNullish(result) ? AusResultStatusIcon[result] : AusResultStatusIcon[AusResult.Incomplete];
  return `<i class="street-light ps-1 ${status}"></i><div class="fw-bold px-1"> DU EA </div> `;
};
